import {
  Certification,
  Church,
  ImageObject,
  OpeningHoursSpecification,
  PostalAddress,
  URL,
  WithContext,
} from "schema-dts";

export const generateChurchSchema = (church: {
  name: string;
  url: string;
  address: PostalAddress;
  telephone?: string;
  image?: ImageObject;
  openingHoursSpecification?: OpeningHoursSpecification[];
  sameAs?: URL[];
  certifications?: Certification[];
  isAccessibleForFree?: boolean;
  alternateName?: string;
}): WithContext<Church> => {
  return {
    "@context": "https://schema.org",
    "@type": "Church",
    name: church.name,
    url: church.url,
    address: church.address,
    telephone: church.telephone,
    image: church.image,
    openingHoursSpecification: church.openingHoursSpecification,
    sameAs: church.sameAs,
    hasCertification: church.certifications,
    isAccessibleForFree: church.isAccessibleForFree,
    alternateName: church.alternateName,
  };
};
